import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import { useQuery, gql } from '@nerdwallet/apollo';
import {
  CenteredContainer,
  Title,
  Button,
  Select,
  Box,
} from '@nerdwallet/currency';

import CompanyDepartmentsTile from './company-departments-tile';
import {
  getDepartmentEnabled,
  getDepartmentRelativePath,
  getSlug,
} from '~/client/lib/department-utils';
import { logGqlError } from '~/client/lib/logger-utils';
import styles from './companyDepartments.module.less';
import NotFound from '~/client/components/company/not-found';

const careersDataQuery = gql`
  query GreenhouseDepartments {
    greenhouseDepartments {
      id
      name
      jobs {
        id
      }
    }
  }
`;

const CompanyDepartments = () => {
  const { data, loading, error } = useQuery(careersDataQuery);
  const [result, setResult] = React.useState('');
  const handleSelectChange = (event) => {
    setResult(event.target.value);
  };

  if (loading) return null;
  if (error || !data?.greenhouseDepartments) {
    if (error) {
      logGqlError(error);
    }
    return <NotFound errorType="departments" />;
  }

  const enabledDepartments = _.filter(
    data.greenhouseDepartments,
    (department) => getDepartmentEnabled(getSlug(department))
  );

  const renderedDepartments = _.map(enabledDepartments, (department) => (
    <CompanyDepartmentsTile department={department} key={department.name} />
  ));
  const findOptions = enabledDepartments.map((department) => ({
    label: department.name,
    value: getDepartmentRelativePath(department),
  }));

  const renderedDepartmentsMobile = (
    <div>
      <div
        className={classNames([
          classes('display-block'),
          classes('margin-horizontal-auto'),
          classes('margin-bottom-4'),
        ])}
      >
        <Select
          onChange={handleSelectChange}
          options={[
            {
              label: 'Select team',
              value: '1',
            },
            ...findOptions,
          ]}
          value={result}
        />
      </div>
      <div
        className={classNames([
          classes('display-block'),
          classes('text-align-center'),
          classes('margin-horizontal-auto'),
          classes('margin-bottom-4'),
        ])}
      >
        <Button href={result} primary>
          see open positions
        </Button>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <Title
        size="small"
        className={classNames([
          classes('margin-bottom-3'),
          classes('margin-bottom-5--wide'),
          classes('text-align-center'),
          classes('display-block'),
          classes('margin-horizontal-auto'),
        ])}
        component="h2"
      >
        Our teams
      </Title>
      <CenteredContainer
        className={classNames([
          classes('display-block'),
          classes('display-none--wide'),
          classes('text-align-center'),
        ])}
      >
        {renderedDepartmentsMobile}
      </CenteredContainer>
      <CenteredContainer>
        <Box className={styles.departmentsCont}>{renderedDepartments}</Box>
      </CenteredContainer>
    </React.Fragment>
  );
};

CompanyDepartments.displayName = 'CompanyDepartments';

export default CompanyDepartments;
